const getters = {
  customerInfo: (state) => {
    const customerInfo = state.customer.customerInfo;
    return customerInfo;
  },
  planInfo: (state) => {
    const planInfo = state.booking.planInfo;
    return planInfo;
  },
  productInfo: (state) => {
    const productInfo = state.booking.productInfo;
    return productInfo;
  },
  bookingUserInfo: (state) => {
    const userInfo = state.booking.userInfo;
    return userInfo;
  },
  formProductInfo: (state) => {
    const formProductInfo = state.booking.formProductInfo;
    return formProductInfo;
  },
  userInfo: (state) => {
    const userInfo = state.user.userInfo;
    return userInfo;
  },
};
export default getters;
